module.exports = __webpack_public_path__ + "static/media/ScratchArea.6c0c23aa.png";